import { Check } from "lucide-react";
import { Reveal } from "@/components/site/Reveal";
import { INCLUDED, IMAGES } from "@/data/content";

export const Included = () => (
  <section id="included" className="bg-white py-20 sm:py-28" data-testid="included-section">
    <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
      <div className="grid gap-12 lg:grid-cols-[0.85fr_1.15fr]">
        <div className="lg:sticky lg:top-28 lg:self-start">
          <Reveal>
            <p className="text-sm font-bold uppercase tracking-widest text-emerald-700">The deep clean standard</p>
            <h2 className="mt-3 font-display text-4xl font-black tracking-tight text-slate-900 sm:text-5xl">
              What Is Included?
            </h2>
            <p className="mt-4 text-lg text-slate-600">
              A room-by-room checklist covering the areas landlords and letting agents inspect most.
            </p>
            <div className="mt-6 overflow-hidden rounded-3xl shadow-[0_20px_60px_rgba(0,0,0,0.08)]">
              <img src={IMAGES.kitchen} alt="Clean, modern kitchen with sunlit worktops after an end of tenancy clean" className="aspect-[4/3] w-full object-cover" loading="lazy" />
            </div>
          </Reveal>
        </div>

        <div className="grid gap-6 sm:grid-cols-2">
          {INCLUDED.map((group, i) => (
            <Reveal key={group.title} delay={i * 0.06}>
              <div className="h-full rounded-3xl border border-slate-200/70 bg-slate-50/60 p-6" data-testid={`included-${group.title.split(" ")[0].toLowerCase()}`}>
                <div className="mb-4 flex items-center gap-3">
                  <span className="flex h-10 w-10 items-center justify-center rounded-xl bg-emerald-700 text-white"><group.icon size={18} /></span>
                  <h3 className="font-display text-lg font-bold text-slate-900">{group.title}</h3>
                </div>
                <ul className="space-y-2">
                  {group.items.map((item) => (
                    <li key={item} className="flex items-start gap-2 text-sm text-slate-600">
                      <Check size={16} className="mt-0.5 shrink-0 text-emerald-600" /> {item}
                    </li>
                  ))}
                </ul>
              </div>
            </Reveal>
          ))}
        </div>
      </div>

      <Reveal>
        <p className="mt-10 rounded-2xl border border-slate-200 bg-slate-50 p-5 text-sm text-slate-600">
          The property should be empty of personal belongings before cleaning. Heavy mould removal,
          construction waste, hazardous materials and specialist restoration are not included unless
          agreed separately.
        </p>
      </Reveal>
    </div>
  </section>
);
